import gql from 'graphql-tag';

export const scenariosQuery = gql`{
  scenarios{
    key
  }
}`;

export const loadScenarioIntoPatientMutation = gql`
  mutation loadScenarioIntoPatient(
    $subjectId: String!
    $scenarioKey: String!
  ) {
    loadScenario(subjectId : $subjectId, scenarioKey : $scenarioKey)
  }`;